module.exports = __webpack_public_path__ + "static/media/multi_popup.4f28ef47.png";